/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteResponse
 */
export interface WriteResponse {
    /**
     * The blockchain transaction hash
     * @type {string}
     * @memberof WriteResponse
     */
    transactionHash?: string;
    /**
     * The blockchain block hash
     * @type {string}
     * @memberof WriteResponse
     */
    blockHash?: string;
    /**
     * The blockchain block number/height
     * @type {number}
     * @memberof WriteResponse
     */
    blockNumber?: number;
}

/**
 * Check if a given object implements the WriteResponse interface.
 */
export function instanceOfWriteResponse(value: object): value is WriteResponse {
    let isInstance = true;

    return isInstance;
}

export function WriteResponseFromJSON(json: any): WriteResponse {
    return WriteResponseFromJSONTyped(json, false);
}

export function WriteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transaction_hash') ? undefined : json['transaction_hash'],
        'blockHash': !exists(json, 'block_hash') ? undefined : json['block_hash'],
        'blockNumber': !exists(json, 'block_number') ? undefined : json['block_number'],
    };
}

export function WriteResponseToJSON(value?: WriteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_hash': value.transactionHash,
        'block_hash': value.blockHash,
        'block_number': value.blockNumber,
    };
}

